"use client";

import { useMarketSelector } from "./useMarketSelector";
import type { MouseEvent } from "react";
import { useCallback } from "react";

import { FEATURE_FLAGS } from "@/config/featureFlags";
import { cn } from "@/lib/utils";
import {
  getMarketSwitchHref,
  marketsByCountryName,
} from "@features/market/config/market-config";

import { MarketItem } from "./MarketPopup";
import MarketSelectorOption from "./MarketSelectorOption";

export default function MarketSelectorList() {
  const { state, onSave } = useMarketSelector();

  const markets = marketsByCountryName();

  const onClick = useCallback(
    (event: MouseEvent<HTMLLIElement>) => {
      event.preventDefault();
      const market = event.currentTarget.getAttribute("data-market");

      if (!market) {
        return;
      }

      const next = markets.find((item) => item.countryCode === market);
      if (!next) return;

      onSave({ link: getMarketSwitchHref(state.market, next) });
    },
    [markets, onSave, state.market],
  );

  return (
    <ul className="flex w-full flex-col divide-y">
      {markets.map((market) => {
        if (FEATURE_FLAGS.marketSelector.new) {
          return <MarketItem key={market.countryCode} market={market} />;
        }
        return (
          <MarketSelectorOption
            key={market.countryCode}
            market={market}
            data-market={market.countryCode}
            as="li"
            role="button"
            onClick={onClick}
            className={cn(
              "px-6 py-4",
              market.countryCode === state.market.countryCode && "bg-gray-100",
            )}
          />
        );
      })}
    </ul>
  );
}
